import Api from '@/api/Api';

class CharityMandateApi extends Api {
  constructor() {
    super('charities/mandate', 'charitiesmandate');
  }
}
const charityMandateApi = new CharityMandateApi();
export default charityMandateApi;
